import { ticCreateApiBase } from 'api/core/tic/tic.createApi.base';
import { syncStatusApi } from 'api/syncStatus/syncStatus.api';
import forecast from 'routes/forecast/redux/modules/forecast.reducer';
import { combineReducersWithMap } from 'utils/redux';
import ticPredictions from '~domains/ai/predictions/redux/predictions.slice';
import ticTimesheetProposals from '~domains/ai/timesheet_proposals/redux/tic.timesheetProposals.slice';
import ticIntegrations from '~domains/integrations/redux/tic.integrations.slice';
import accounts from './accounts';
import activities from './activities.reducer';
import apps from './apps.reducer';
import calendar from './calendar.reducer';
import capacities from './capacities';
import changelog from './changelog';
import clients from './clients';
import appClients from './clients.sync';
import currencies from './currencies';
import dayProperties from './dayProperties';
import development from './development';
import global from './global';
import hourStates from './hourStates';
import hourSummary from './hourSummary.reducer';
import hours from './hours.reducer';
import integrations from './integrations.reducer';
import invoice from './invoice.reducer';
import messages from './messages';
import notificationSettings from './notificationSettings';
import notifications from './notifications';
import onboarding from './onboarding';
import pins from './pins.reducer';
import projectSubscriptions from './projectSubscriptions';
import projects from './projects.reducer';
import projectTemplates from './projectTemplates';
import roles from './roles.reducer';
import router from './router';
import subscriptions from './subscriptions.reducer';
import suggestions from './suggestions';
import summaries from './summaries';
import superreports from './superreports';
import tags from './tags.reducer';
import teams from './teams';
import ticAiAgent from './tic/agent/tic.ai.agent.slice';
import ticTasks from './tic/tasks/tic.tasks.slice';
import ticAuth from './tic/tic.auth';
import ticConfigDefaults from './tic/tic.config_defaults';
import ticGlobal from './tic/tic.global';
import timeline from './timeline.reducer';
import toasts from './toasts.reducer';
import userEditor from './user.editor.reducer';
import user from './user.reducer';
import userPage from './user-page.reducer';
import users from './users.reducer';
import usersPage from './users-page/usersPage.reducer';

const rootReducer = combineReducersWithMap({
  accounts,
  activities,
  appClients,
  apps,
  calendar,
  capacities,
  changelog,
  clients,
  currencies,
  dayProperties,
  development,
  forecast,
  global,
  hours,
  hourSummary,
  hourStates,
  integrations,
  invoice,
  messages,
  notifications,
  notificationSettings,
  onboarding,
  pins,
  projectTemplates,
  projects,
  projectSubscriptions,
  roles,
  router,
  subscriptions,
  suggestions,
  summaries,
  superreports,
  tags,
  teams,
  timeline,
  ticGlobal,
  ticAuth,
  ticConfigDefaults,
  ticPredictions,
  ticAiAgent,
  ticTasks,
  ticIntegrations,
  ticTimesheetProposals,
  toasts,
  user,
  userPage,
  userEditor,
  users,
  usersPage,
  [ticCreateApiBase.reducerPath]: ticCreateApiBase.reducer,
  [syncStatusApi.reducerPath]: syncStatusApi.reducer,
});

export default rootReducer;
